import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Register service worker with debugging
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log("[Service Worker] Registered successfully.");
  },
  onUpdate: (registration) => {
    if (window.confirm("New version available. Do you want to refresh?")) {
      window.location.reload();
    }
  },
});

// Unregister service workers and clear cache after session
const clearServiceWorkersAndCache = async () => {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (let registration of registrations) {
      await registration.unregister();
      console.log("[Service Worker] Unregistered:", registration);
    }
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => caches.delete(cacheName));
    });
    console.log("[Service Worker] Cache cleared.");
  }
};

// Call this function at the end of the session
clearServiceWorkersAndCache();

// Main application rendering
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure app performance
reportWebVitals(console.log);
